import React from 'react'
import Navbar from '../../components/shared/Navbar'
import PackagesContainer from './Packages'

export default function EventsPage() {
    return (
        <>
            <Navbar/>
            
            <section className="section">
                <div className="container">
                    
                    <div className="hero is-bold is-primary">
                    <div className="hero-body">
                        <p className="subtitle is-4">COChilorios para</p>
                        <p className="title is-1">Tus eventos</p>
                        <p className="subtitle is-5">Nosotros te atendemos</p>
                    </div>
                    </div>

                    <div className="columns mt-2">
                        <div className="column is-6">
                            <div className="box">
                            <div className="container">
                                <p>Pedidos por persona</p>
                            </div>
                            </div>
                        </div>
                        <div className="column is-6">
                            <p>Aquí va una imagen</p>
                        </div>

                    </div>
                    
                    <div className="columns mt-2">
                        <PackagesContainer/>
                    </div>
                </div>
            </section>


        </>
    )
}
